export default "__VITE_ASSET__LvOJhKd7oX2Gi43xkSh4$Q__";